import { useMemo, useCallback } from 'react';
import { useStore } from 'store';
import { Loader, ResponseModal } from 'components';
import { closeResponseModal } from 'store/actions/commons';
import {
  DEFAULT_SUCCESS_TITLE,
  DEFAULT_SUCCESS_MESSAGE,
  DEFAULT_ERROR_TITLE,
  DEFAULT_ERROR_MESSAGE,
} from './constants';

const META = 'FROM_COMMONS';

export default function Commons() {
  const [commons, dispatch] = useStore((state) => state.commons);
  const { responseModal } = commons;

  const handleClose = useCallback(() => {
    dispatch(closeResponseModal());
  }, []);

  const handleAction = useCallback(() => {
    if (responseModal.customAction) {
      const payload = { closeResponseModal, meta: META };
      dispatch(responseModal.customAction(payload));
      return;
    }
    if (responseModal.customCallback) {
      responseModal.customCallback();
    }

    handleClose();
  }, [handleClose, responseModal]);

  const responseModalProps = useMemo(() => {
    const title = responseModal.error
      ? DEFAULT_ERROR_TITLE
      : responseModal.success
      ? DEFAULT_SUCCESS_TITLE
      : '';

    const message = responseModal.error
      ? DEFAULT_SUCCESS_MESSAGE
      : responseModal.success
      ? DEFAULT_ERROR_MESSAGE
      : '';

    return {
      title:
        responseModal.title && responseModal.title !== 'Error'
          ? responseModal.title
          : title,
      message: responseModal.message || message,
      show: responseModal.show,
      success: responseModal.success,
      error: responseModal.error,
      actionType: responseModal.actionType,
    };
  }, [responseModal]);

  return (
    <>
      <Loader show={Boolean(commons.loader)} />

      <ResponseModal
        {...responseModalProps}
        onClose={handleClose}
        onAction={handleAction}
      />
    </>
  );
}
